import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sso-page',
  templateUrl: './sso-page.component.html',
  styleUrls: ['./sso-page.component.css']
})
export class SsoPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/theme/sso-page/sso-page.component.ts